import { render, staticRenderFns } from "./WarrantyInternalList.vue?vue&type=template&id=a2d64ce2"
import script from "./WarrantyInternalList.vue?vue&type=script&lang=js"
export * from "./WarrantyInternalList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports